// @ts-strict-ignore
import { technologyPartnersDetailsNRO } from "@navigationRouting/integrations/technology_partners/:partnerId/:appGroupId";

import { alloysShopifyBridgeIdEditNRO } from "./alloys/shopify/__bridgeId/edit/__appGroupId/";
import { botTrackingSettingsNRO } from "./app_settings/app_settings/email_settings/bot_filtering/__appGroupId/botTrackingSettingsNRO";
import { delegatedDomainDetailNRO } from "./company_settings/verified_domains/__appGroupId/delegated_domains/__companyId/__id";
import { dashboardCatalogsCatalogIdSelectionSelectionNameNRO } from "./dashboard/catalogs/__catalogId/selection/__selectionName/dashboardCatalogsCatalogIdSelectionSelectionNameNRO";
import { offerfitDimensionDetailsNRO } from "./decisioning_studio/agents/__dsaId/dimensions/__dimensionSlug/__appGroupId";
import { canvasTemplatesDetailsNRO } from "./engagement/templates_and_media/canvas_templates/__appGroupId/__canvasTemplateId/canvasTemplatesDetailsNRO";
import { contentBlockInclusionsNRO } from "./engagement/templates_and_media/content_blocks/__appGroupId/__contentBlockId/inclusions";
import { dragAndDropEmailEditorSettingsNRO } from "./app_settings/app_settings/email_settings/drag_and_drop_email/__appGroupId";
import { linkAliasingSettingsNRO } from "./app_settings/app_settings/email_settings/link_aliasing/__appGroupId";
import { sendingConfigurationNRO } from "./app_settings/app_settings/email_settings/sending_configuration/__appGroupId";
import { subscriptionPagesAndFootersNRO } from "./app_settings/app_settings/email_settings/subscription_pages_and_footers/__appGroupId";
import { appSettingsMessagePrioritizationCategorySettingsNRO } from "./app_settings/app_settings/message_prioritization/category_settings/__app_group_id";
import { appSettingsMessagePrioritizationRuleSettingsNRO } from "./app_settings/app_settings/message_prioritization/prioritization_rule_settings/__appGroupId";
import { placementDetailsNRO } from "./app_settings/app_settings/placements/__placementId/__appGroupId";
import { internalGroupDetailsNRO } from "./app_settings/developer_console/internal_groups/__internalGroupId/__appGroupId";
import { workspaceRateLimitsNRO } from "./company_settings/admin_settings/workspace_rate_limits/__appGroupId/workspaceRateLimitsNRO";
import { workspaceTimeZonesNRO } from "./company_settings/admin_settings/workspace_time_zones/__appGroupId/workspaceTimeZonesNRO";
import { customDomainsDetailsNRO } from "./company_settings/custom_domains/__domainType/__domainId/__appGroupId";
import { dashboardCatalogsCatalogIdNewSelectionNRO } from "./dashboard/catalogs/__catalogId/new-selection/dashboardCatalogsCatalogIdNewSelectionNRO";
import { reportBuilder2EditNRO } from "./dashboard/report_builder_2/edit/__report_id/__appGroupId";
import { dashboardBuilderNRO } from "./dashboard/report_dashboard/__report_dashboard_id/./__appGroupId";
import { calculatedFiltersEditNRO } from "./engagement/calculated_filters/edit/__calculatedFilterId/__appGroupId";
import { canvasStepDetailsNRO } from "./engagement/canvas/__canvasId/__stepId/__appGroupId";
import { segmentCohortsEditNRO } from "./engagement/segment_cohorts/edit/__segmentCohortId/__appGroupId";
import { segmentEditNRO } from "./engagement/segmenter/edit/__segmentId/__appGroupId";
import { bannerTemplateDetailsNRO } from "./engagement/templates_and_media/banner_templates/__appGroupId/__templateId";
import { savedContentBlockNRO } from "./engagement/templates_and_media/content_blocks/__appGroupId/__contentBlockId";
import { newContentBlockNRO } from "./engagement/templates_and_media/content_blocks/__appGroupId/new";
import { engagementTemplatesAndMediaEmailTemplatesIdNRO } from "./engagement/templates_and_media/email_templates/__appGroupId/__id";
import { engagementTemplatesAndMediaEmailTemplatesNewNRO } from "./engagement/templates_and_media/email_templates/__appGroupId/new";
import { landingPageTemplateDetailsNRO } from "./engagement/templates_and_media/landing_page_templates/__appGroupId/__templateId";
import { engagementTemplatesAndMediaWebhookTemplatesTemplateIdNRO } from "./engagement/templates_and_media/webhook_templates/__appGroupId/__templateId";
import { WhatsAppTemplatesCreateNRO } from "./engagement/templates_and_media/whats_app_templates/new/__appGroupId";
import { integrationsCurrentsIntegrationsEditPillNRO } from "./integrations/currents_integrations/__pill/edit/__app_group_id";
import { databricksDeltashareCreateNRO } from "./integrations/datashares_integrations/create/deltashare/__appGroupId";
import { databricksDeltashareNRO } from "./integrations/datashares_integrations/deltashare/__sharingId/__appGroupId";
import { promotionCodeCreateNRO } from "./integrations/vouchers/new/__appGroupId/promotionCodeCreateNRO";
import { usersPreferenceCentersIdNRO } from "./users/subscription_groups/preference_centers/__appGroupId/__id";
import { usersPreferenceCentersNewNRO } from "./users/subscription_groups/preference_centers/__appGroupId/new";
import { aiAgentDetailsNRO } from "./agent_console/agents/__agentId/__appGroupId";
import { brandGuidelinesNRO } from "./app_settings/app_settings/brand_guidelines/__appGroupId";
import { connectedContentNRO } from "./app_settings/app_settings/connected_content/__appGroupId";
import { customAttributesNRO } from "./app_settings/app_settings/custom_attributes/__appGroupId";
import { customEventsNRO } from "./app_settings/app_settings/custom_events/__appGroupId";
import { emailPreferencesNRO } from "./app_settings/app_settings/email_settings/__appGroupId";
import { globalRateLimitsNRO } from "./app_settings/app_settings/global_rate_limits/__appGroupId";
import { landingPageSettingsNRO } from "./app_settings/app_settings/landing_pages/__appGroupId";
import { approvalWorkflowNRO } from "./app_settings/app_settings/manage_approval_settings/__appGroupId";
import { messageArchivingNRO } from "./app_settings/app_settings/message_archiving_settings/__appGroupId";
import { appSettingsMessagePrioritizationNRO } from "./app_settings/app_settings/message_prioritization/__app_group_id";
import { multiLanguageSupportNRO } from "./app_settings/app_settings/multi_language_settings/__appGroupId";
import { placementsNRO } from "./app_settings/app_settings/placements/__appGroupId";
import { productsNRO } from "./app_settings/app_settings/products/__appGroupId";
import { pushSettingsNRO } from "./app_settings/app_settings/push/__appGroupId";
import { appSettingsNRO } from "./app_settings/app_settings/settings/__appGroupId";
import { tagManagementNRO } from "./app_settings/app_settings/tags/__appGroupId";
import { internalTeamsNRO } from "./app_settings/app_settings/territories/__appGroupId";
import { activityLogNRO } from "./app_settings/developer_console/activitylog/__appGroupId";
import { apiSettingsNRO } from "./app_settings/developer_console/apisettings/__appGroupId";
import { eventUserLogNRO } from "./app_settings/developer_console/event_user_log/__appGroupId";
import { internalGroupsNRO } from "./app_settings/developer_console/internal_groups/__appGroupId";
import { userDataEncryptionNRO } from "./app_settings/developer_console/user_data_encryption/__appGroupId";
import { aiSettingsNRO } from "./company_settings/admin_settings/ai-settings-management/__appGroupId";
import { automatedUserProvisioningNRO } from "./company_settings/admin_settings/automated-user-provisioning/__appGroupId";
import { contactInfoNRO } from "./company_settings/admin_settings/company-settings-management/__appGroupId";
import { notificationPreferencesNRO } from "./company_settings/admin_settings/notification-management/__appGroupId";
import { securitySettingsNRO } from "./company_settings/admin_settings/security-management/__appGroupId";
import { consumptionReportingNRO } from "./company_settings/subscriptions_and_billing/consumption-reporting/:appGroupId";
import { dataPointsNRO } from "./company_settings/subscriptions_and_billing/data-points-breakdown/__appGroupId";
import { lookerDataPointsNRO } from "./company_settings/subscriptions_and_billing/looker-data-points-dashboard/__appGroupId";
import { subscriptionAndUsageNRO } from "./company_settings/subscriptions_and_billing/subscriptions-and-usage/__appGroupId";
import { verifiedDomainsNRO } from "./company_settings/verified_domains/__appGroupId/verifiedDomainsNRO";
import { dashboardCatalogsCatalogIdNRO } from "./dashboard/catalogs/__catalogId/__appGroupId";
import { dataTransformationsNRO } from "./dashboard/data_transformations/data_transformations/__appGroupId";
import { dashboardEngagementReportsEngagementReportIdNRO } from "./dashboard/engagement_reports/__engagementReportId/__appGroupId";
import { dashboardEngagementReportsNewReportNRO } from "./dashboard/engagement_reports/new-report/__appGroupId";
import { dashboardExportLogsDetailsNRO } from "./dashboard/export_logs/__logId/__appGroupId";
import { reportBuilder2ResultsNRO } from "./dashboard/report_builder_2/__report_id/__appGroupId";
import { offerfitUseCaseDetailsNRO } from "./decisioning_studio/agents/__dsaId/__appGroupId";
import { calculatedFiltersCreateNRO } from "./engagement/calculated_filters/create/__appGroupId";
import { campaignDetailsNRO } from "./engagement/campaigns/__campaignId/__appGroupId";
import { contentCalendarNRO } from "./engagement/campaigns/future_send_calendar/__appGroupId";
import { canvasDetailsNRO } from "./engagement/canvas/__canvasId/__appGroupId";
import { ipWarmingNRO } from "./engagement/email/ip_warming/__appGroupId";
import { featureFlagsDetailsNRO } from "./engagement/feature_flags/__featureFlagId/__appGroupId";
import { globalControlNRO } from "./engagement/global_message_settings/global-control-settings/__appGroupId";
import { frequencyCappingRulesNRO } from "./engagement/global_message_settings/global-message-settings/__appGroupId";
import { landingPagesDetailsNRO } from "./engagement/landing_pages/__landingPageId/__appGroupId";
import { locationDetailsNRO } from "./engagement/locations/__locationId/__appGroupId";
import { PredictionDetailsNRO } from "./engagement/predictions/__predictionId/__appGroupId";
import { predictionsNRO } from "./engagement/predictions/predictions/__appGroupId";
import { segmentCohortsNRO } from "./engagement/segment_cohorts/__segmentCohortId/__appGroupId";
import { segmentCohortsCreateNRO } from "./engagement/segment_cohorts/create/__appGroupId";
import { segmentInsightsNRO } from "./engagement/segmenter/segment_insights/__appGroupId";
import { suppressionListsDetailsNRO } from "./engagement/suppression_lists/__suppressionListId/__appGroupId";
import { bannerTemplatesNRO } from "./engagement/templates_and_media/banner_templates/__appGroupId";
import { canvasTemplatesNRO } from "./engagement/templates_and_media/canvas_templates/__appGroupId";
import { contentBlocksNRO } from "./engagement/templates_and_media/content_blocks/__appGroupId";
import { emailTemplatesNRO } from "./engagement/templates_and_media/email_templates/__appGroupId";
import { inAppColorProfilesNRO } from "./engagement/templates_and_media/in_app_message_color_profiles/__appGroupId";
import { landingPageTemplatesNRO } from "./engagement/templates_and_media/landing_page_templates/__appGroupId";
import { linkTemplatesNRO } from "./engagement/templates_and_media/link_templates/__appGroupId";
import { mediaLibraryNRO } from "./engagement/templates_and_media/media_library/__appGroupId";
import { webhookTemplatesNRO } from "./engagement/templates_and_media/webhook_templates/__appGroupId";
import { engagementTemplatesAndMediaWhatsAppTemplatesNRO } from "./engagement/templates_and_media/whats_app_templates/__appGroupId";
import { integrationsCurrentsIntegrationsNewDestinationNRO } from "./integrations/currents_integrations/new/__destination";
import { datasharesIntegrationNRO } from "./integrations/datashares_integrations/__datashareIntegration/__appGroupId";
import { datasharesIntegrationCreateNRO } from "./integrations/datashares_integrations/create/__appGroupId";
import { technologyPartnersListNRO } from "./integrations/technology_partners/__technologyPartners/__appGroupId";
import { promotionCodeDetailsNRO } from "./integrations/vouchers/__voucherId/__appGroupId";
import { promotionCodesNRO } from "./integrations/vouchers/vouchers/__appGroupId";
import { knowledgeSourceEditNRO } from "./knowledge_source/edit/__knowledgeSourceId/__appGroupId";
import { usersSubscriptionGroupsSubscriptionGroupIdNRO } from "./users/subscription_groups/__subscriptionGroupId/__appGroupId";
import { usersPreferenceCentersNRO } from "./users/subscription_groups/preference_centers/__app_group_id";
import { subscriptionAnalyticsNRO } from "./users/subscription_groups/subscription_analytics/__appGroupId";
import { subscriptionGroupsNRO } from "./users/subscription_groups/subscription_groups/__appGroupId";
import { aiAgentsNRO } from "./agent_console/agents/__appGroupId";
import { alloysShopifyNRO } from "./alloys/shopify/__appGroupId";
import { customerSuccessAccessNRO } from "./appboy_admin/impersonation/__appGroupId";
import { linkImpersonationNRO } from "./appboy_admin/link_impersonation/__appGroupId";
import { companySettingsAccountSettingsNRO } from "./company_settings/account_settings/:appGroupId";
import { adminSettingsNRO } from "./company_settings/admin_settings/__appGroupId";
import { customDomainsNRO } from "./company_settings/custom_domains/__appGroupId";
import { emailSelfServeNRO } from "./company_settings/email_self_serve/__appGroupId";
import { companyUsersNRO } from "./company_settings/manage_users/__appGroupId";
import { permissionSettingsNRO } from "./company_settings/permission_settings/__appGroupId";
import { senderVerificationNRO } from "./company_settings/sender_verification/__appGroupId";
import { billingNRO } from "./company_settings/subscriptions_and_billing/__appGroupId";
import { AccountsNRO } from "./dashboard/accounts/__appGroupId";
import { emailPerformanceNRO } from "./dashboard/analytics_dashboard/__appGroupId";
import { smsPerformanceNRO } from "./dashboard/analytics_dashboard_sms/__appGroupId";
import { catalogsNRO } from "./dashboard/catalogs/__appGroupId";
import { conversionsNRO } from "./dashboard/conversion_attribution/__appGroupId";
import { customEventsReportNRO } from "./dashboard/custom_events/__appGroupId";
import { dashboardEngagementReportsNRO } from "./dashboard/engagement_reports/__appGroupId";
import { dashboardExportLogsNRO } from "./dashboard/export_logs/__appGroupId";
import { globalControlReportNRO } from "./dashboard/global_control/__appGroupId";
import { queryBuilderNRO } from "./dashboard/query_builder/__appGroupId";
import { reportBuilderNRO } from "./dashboard/report_builder/__appGroupId";
import { reportBuilder2NRO } from "./dashboard/report_builder_2/__appGroupId";
import { dashboardBuilderDigestNRO } from "./dashboard/report_dashboard/__appGroupId";
import { revenueReportNRO } from "./dashboard/revenue/__appGroupId";
import { calculatedFiltersListNRO } from "./engagement/calculated_filters/__appGroupId";
import { campaignsNRO } from "./engagement/campaigns/__appGroupId";
import { canvasNRO } from "./engagement/canvas/__appGroupId";
import { featureFlagsNRO } from "./engagement/feature_flags/__appGroupId";
import { landingPagesNRO } from "./engagement/landing_pages/__appGroupId";
import { locationsNRO } from "./engagement/locations/__appGroupId";
import {
  engagementPredictionsNewPurchaseNRO,
  engagementPredictionsNewChurnNRO,
  engagementPredictionsNewRecommendationNRO,
} from "./engagement/predictions/new";
import { suppressionListsNRO } from "./engagement/suppression_lists/__appGroupId";
import { cloudDataIngestionNRO } from "./integrations/cloud_data_ingestion/__appGroupId";
import { currentsIntegrationsNRO } from "./integrations/currents_integrations/__appGroupId";
import { datasharesIntegrationsNRO } from "./integrations/datashares_integrations/__appGroupId";
import { knowledgeSourceCreateNRO } from "./knowledge_source/create/__appGroupId";
import { sdkDebuggerNRO } from "./sdk/debugger/__appGroupId";
import { manageAudienceNRO } from "./users/manage_audience/__appGroupId";
import { importUsersNRO } from "./users/user_import/__appGroupId";
import { searchUsersNRO } from "./users/user_search/__appGroupId";
import { dashboardAppUsageNRO } from "./dashboard/app_usage";
import { offerfitUseCasesNRO } from "./decisioning_studio/agents";
import { segmenterNRO } from "./engagement/segmenter";
import { toolsDashboardNRO } from "./internal_tools/internal";
import { knowledgeSourceNRO } from "./knowledge_source/__appGroupId";
import { mongoExplorerNRO } from "./mongo_explorer/all_schemas";
import { roadmapNRO } from "./roadmap";
import type { ComponentFeatureFlippers, VerifyDashboardPathnames } from "./types";

/* eslint-disable sort-keys */
/**
 * Define navigation routes for the dashboard
 *
 * These routes allow dynamic configuration of navigation menus, and also configuration of searching for navigation features
 *
 * NOTE: please do not edit this file directly. Instead, use the 'yarn scaffold' > 'nros' > 'addToGroup' command to add paths from routing groups.
 *
 * For help adding these, see the documentation at:
 * https://confluence.braze.com/x/nAKvEw#Navigation,RoutingandRenderinginReact-CreatinganewNRO
 */
export const navigationRoutingRegistry = makeNavigationRouting({
  "/alloys/shopify/:appGroupId": alloysShopifyNRO,
  "/alloys/shopify/:bridgeId/:appGroupId": alloysShopifyNRO,
  "/alloys/shopify/:bridgeId/edit/:appGroupId": alloysShopifyBridgeIdEditNRO,
  "/app_settings/app_settings/:appGroupId": appSettingsNRO,
  "/app_settings/app_settings/brand_guidelines/:appGroupId": brandGuidelinesNRO,
  "/app_settings/app_settings/connected_content/:appGroupId": connectedContentNRO,
  "/app_settings/app_settings/custom_attributes/:appGroupId": customAttributesNRO,
  "/app_settings/app_settings/custom_events/:appGroupId": customEventsNRO,
  "/app_settings/app_settings/email_settings/:appGroupId": emailPreferencesNRO,
  "/app_settings/app_settings/email_settings/drag_and_drop_email/:appGroupId": dragAndDropEmailEditorSettingsNRO,
  "/app_settings/app_settings/email_settings/link_aliasing/:appGroupId": linkAliasingSettingsNRO,
  "/app_settings/app_settings/email_settings/sending_configuration/:appGroupId": sendingConfigurationNRO,
  "/app_settings/app_settings/email_settings/subscription_pages_and_footers/:appGroupId":
    subscriptionPagesAndFootersNRO,
  "/app_settings/app_settings/email_settings/bot_filtering/:appGroupId": botTrackingSettingsNRO,
  "/app_settings/app_settings/global_rate_limits/:appGroupId": globalRateLimitsNRO,
  "/app_settings/app_settings/landing_pages/:appGroupId": landingPageSettingsNRO,
  "/app_settings/app_settings/manage_approval_settings/:appGroupId": approvalWorkflowNRO,
  "/app_settings/app_settings/message_archiving_settings/:appGroupId": messageArchivingNRO,
  "/app_settings/app_settings/message_prioritization/:appGroupId": appSettingsMessagePrioritizationNRO,
  "/app_settings/app_settings/message_prioritization/category_settings/:appGroupId":
    appSettingsMessagePrioritizationCategorySettingsNRO,
  "/app_settings/app_settings/message_prioritization/prioritization_rule_settings/:appGroupId":
    appSettingsMessagePrioritizationRuleSettingsNRO,
  "/app_settings/app_settings/multi_language_settings/:appGroupId": multiLanguageSupportNRO,
  "/app_settings/app_settings/placements/:appGroupId": placementsNRO,
  "/app_settings/app_settings/placements/:placementId/:appGroupId": placementDetailsNRO,
  "/app_settings/app_settings/products/:appGroupId": productsNRO,
  "/app_settings/app_settings/push/:appGroupId": pushSettingsNRO,
  "/app_settings/app_settings/settings/:appGroupId": appSettingsNRO,
  "/app_settings/app_settings/tags/:appGroupId": tagManagementNRO,
  "/app_settings/app_settings/territories/:appGroupId": internalTeamsNRO,
  "/app_settings/developer_console/activitylog/:appGroupId": activityLogNRO,
  "/app_settings/developer_console/apisettings/:appGroupId": apiSettingsNRO,
  "/app_settings/developer_console/event_user_log/:appGroupId": eventUserLogNRO,
  "/app_settings/developer_console/internal_groups/:appGroupId": internalGroupsNRO,
  "/app_settings/developer_console/internal_groups/:internalGroupId/:appGroupId": internalGroupDetailsNRO,
  "/app_settings/developer_console/user_data_encryption/:appGroupId": userDataEncryptionNRO,
  "/appboy_admin/impersonation/:appGroupId": customerSuccessAccessNRO,
  "/appboy_admin/link_impersonation/:appGroupId": linkImpersonationNRO,
  "/agent_console/agents/:agentId/:appGroupId": aiAgentDetailsNRO,
  "/agent_console/agents/:appGroupId": aiAgentsNRO,
  "/company_settings/account_settings/:appGroupId": companySettingsAccountSettingsNRO,
  "/company_settings/admin_settings/:appGroupId": adminSettingsNRO,
  "/company_settings/admin_settings/ai-settings-management/:appGroupId": aiSettingsNRO,
  "/company_settings/admin_settings/automated-user-provisioning/:appGroupId": automatedUserProvisioningNRO,
  "/company_settings/admin_settings/company-settings-management/:appGroupId": contactInfoNRO,
  "/company_settings/admin_settings/notification-management/:appGroupId": notificationPreferencesNRO,
  "/company_settings/admin_settings/security-management/:appGroupId": securitySettingsNRO,
  "/company_settings/admin_settings/workspace_rate_limits/:appGroupId": workspaceRateLimitsNRO,
  "/company_settings/admin_settings/workspace_time_zones/:appGroupId": workspaceTimeZonesNRO,
  "/company_settings/custom_domains/:appGroupId": customDomainsNRO,
  "/company_settings/verified_domains/:appGroupId": verifiedDomainsNRO,
  "/company_settings/verified_domains/:appGroupId/delegated_domains/:companyId/:id": delegatedDomainDetailNRO,
  "/company_settings/custom_domains/:domainType/:domainId/:companyId/:appGroupId": customDomainsDetailsNRO,
  "/company_settings/email_self_serve/:appGroupId": emailSelfServeNRO,
  "/company_settings/manage_users/:appGroupId": companyUsersNRO,
  "/company_settings/manage_users/:appGroupId/:userId": companyUsersNRO,
  "/company_settings/manage_users/developers/:appGroupId": companyUsersNRO,
  "/company_settings/permission_settings/:appGroupId": permissionSettingsNRO,
  "/company_settings/sender_verification/:appGroupId": senderVerificationNRO,
  "/company_settings/sender_verification/sender-verification/:appGroupId": senderVerificationNRO,
  "/company_settings/subscriptions_and_billing/:appGroupId": billingNRO,
  "/company_settings/subscriptions_and_billing/consumption-reporting/:appGroupId": consumptionReportingNRO,
  "/company_settings/subscriptions_and_billing/data-points-breakdown/:appGroupId": dataPointsNRO,
  "/company_settings/subscriptions_and_billing/looker-data-points-dashboard/:appGroupId": lookerDataPointsNRO,
  "/company_settings/subscriptions_and_billing/subscriptions-and-usage/:appGroupId": subscriptionAndUsageNRO,
  "/dashboard/accounts/:appGroupId": AccountsNRO,
  "/dashboard/analytics_dashboard/:appGroupId": emailPerformanceNRO,
  "/dashboard/analytics_dashboard_sms/:appGroupId": smsPerformanceNRO,
  "/dashboard/app_usage/:appGroupId": dashboardAppUsageNRO,
  "/dashboard/app_usage/app-usage/:appGroupId": dashboardAppUsageNRO,
  "/dashboard/catalogs/:appGroupId": catalogsNRO,
  "/dashboard/catalogs": catalogsNRO,
  "/dashboard/catalogs/:catalogId/new-selection/:appGroupId": dashboardCatalogsCatalogIdNewSelectionNRO,
  "/dashboard/catalogs/:catalogId/selection/:selectionName/:appGroupId":
    dashboardCatalogsCatalogIdSelectionSelectionNameNRO,
  "/dashboard/catalogs/:catalogId/:appGroupId": dashboardCatalogsCatalogIdNRO,
  "/dashboard/conversion_attribution/:appGroupId": conversionsNRO,
  "/dashboard/custom_events/:appGroupId": customEventsReportNRO,
  "/dashboard/custom_events/custom-events/:appGroupId": customEventsReportNRO,
  "/dashboard/data_transformations/data_transformations/:appGroupId": dataTransformationsNRO,
  "/dashboard/data_transformations/:appGroupId": dataTransformationsNRO,
  "/dashboard/data_transformations/:dataTransformationId/:appGroupId": dataTransformationsNRO,
  "/dashboard/engagement_reports/:appGroupId": dashboardEngagementReportsNRO,
  "/dashboard/engagement_reports/new-report-1/:appGroupId": dashboardEngagementReportsNewReportNRO,
  "/dashboard/engagement_reports/:engagementReportId/:appGroupId": dashboardEngagementReportsEngagementReportIdNRO,
  "/dashboard/report_builder_2/:appGroupId": reportBuilder2NRO,
  "/dashboard/report_builder_2/:report_id/:appGroupId": reportBuilder2ResultsNRO,
  "/dashboard/report_builder_2/edit/:report_id/:appGroupId": reportBuilder2EditNRO,
  "/dashboard/global_control/:appGroupId": globalControlReportNRO,
  "/dashboard/query_builder/:appGroupId": queryBuilderNRO,
  "/dashboard/report_builder/:appGroupId": reportBuilderNRO,
  "/dashboard/report_builder/:appGroupId/results/:reportId": reportBuilderNRO,
  "/dashboard/report_builder_2/new/:appGroupId": reportBuilder2EditNRO,
  "/dashboard/report_dashboard/:report_dashboard_id/:appGroupId": dashboardBuilderNRO,
  "/dashboard/report_dashboard/:appGroupId": dashboardBuilderDigestNRO,
  "/dashboard/revenue/:appGroupId": revenueReportNRO,
  "/dashboard/revenue/revenue/:appGroupId": revenueReportNRO,
  "/dashboard/export_logs/:appGroupId": dashboardExportLogsNRO,
  "/dashboard/export_logs/:logId/:appGroupId": dashboardExportLogsDetailsNRO,
  "/engagement/campaigns/:appGroupId": campaignsNRO,
  "/engagement/campaigns/:campaignId/:appGroupId": campaignDetailsNRO,
  "/engagement/campaigns/future_send_calendar/:appGroupId": contentCalendarNRO,
  "/engagement/canvas/:canvasId/:stepId/:appGroupId": canvasStepDetailsNRO,
  "/engagement/canvas/:appGroupId": canvasNRO,
  "/engagement/canvas/canvas/:appGroupId": canvasNRO,
  "/engagement/canvas/:canvasId/:appGroupId": canvasDetailsNRO,
  "/engagement/email/ip_warming/:appGroupId": ipWarmingNRO,
  "/engagement/feature_flags/:appGroupId": featureFlagsNRO,
  "/engagement/feature_flags/:featureFlagId/:appGroupId": featureFlagsDetailsNRO,
  "/engagement/global_message_settings/global-control-settings/:appGroupId": globalControlNRO,
  "/engagement/predictions/new/churn/:appGroupId": engagementPredictionsNewChurnNRO,
  "/engagement/predictions/new/purchase/:appGroupId": engagementPredictionsNewPurchaseNRO,
  "/engagement/predictions/new/recommendation/:appGroupId": engagementPredictionsNewRecommendationNRO,
  "/engagement/predictions/:predictionId/:appGroupId": PredictionDetailsNRO,
  "/engagement/calculated_filters/:appGroupId": calculatedFiltersListNRO,
  "/engagement/calculated_filters/create/:appGroupId": calculatedFiltersCreateNRO,
  "/engagement/calculated_filters/edit/:calculatedFilterId/:appGroupId": calculatedFiltersEditNRO,
  "/engagement/segment_cohorts/create/:appGroupId": segmentCohortsCreateNRO,
  "/engagement/segment_cohorts/edit/:segmentCohortId/:appGroupId": segmentCohortsEditNRO,
  "/engagement/segmenter/edit/:segmentId/:appGroupId": segmentEditNRO,
  "/engagement/suppression_lists/:appGroupId": suppressionListsNRO,
  "/engagement/suppression_lists/:suppressionListId/:appGroupId": suppressionListsDetailsNRO,
  "/engagement/global_message_settings/global-message-settings/:appGroupId": frequencyCappingRulesNRO,
  "/engagement/global_message_settings/:appGroupId": frequencyCappingRulesNRO,
  "/engagement/landing_pages/:appGroupId": landingPagesNRO,
  "/engagement/landing_pages/create_landing_page/:appGroupId": landingPagesDetailsNRO,
  "/engagement/landing_pages/:landingPageBsonId/:appGroupId": landingPagesDetailsNRO,
  "/engagement/locations/:appGroupId": locationsNRO,
  "/engagement/locations/:geofenceSetId/:appGroupId": locationDetailsNRO,
  "/engagement/predictions/predictions/:appGroupId": predictionsNRO,
  "/engagement/segment_cohorts/segment_cohorts/:appGroupId": segmentCohortsNRO,
  "/engagement/segment_cohorts/:segmentCohortId/:appGroupId": segmentCohortsNRO,
  "/engagement/segmenter/:appGroupId": segmenterNRO,
  "/engagement/segmenter/segmenter": segmenterNRO,
  "/engagement/segmenter/segmenter/:appGroupId": segmenterNRO,
  "/engagement/segmenter/segment_insights/:appGroupId": segmentInsightsNRO,
  "/engagement/segmenter/segment_insights": segmentInsightsNRO,
  "/engagement/segmenter/:segmentId/:appGroupId": segmenterNRO,
  "/engagement/segmenter/:segmenter/:appGroupId": segmenterNRO,
  "/engagement/templates_and_media/banner_templates/:appGroupId": bannerTemplatesNRO,
  "/engagement/templates_and_media/banner_templates/:appGroupId/new": bannerTemplateDetailsNRO,
  "/engagement/templates_and_media/banner_templates/:appGroupId/:templateId": bannerTemplateDetailsNRO,
  "/engagement/templates_and_media/canvas_templates/:appGroupId": canvasTemplatesNRO,
  "/engagement/templates_and_media/canvas_templates/:appGroupId/:canvasTemplateId": canvasTemplatesDetailsNRO,
  "/engagement/templates_and_media/content_blocks/:appGroupId/new": newContentBlockNRO,
  "/engagement/templates_and_media/content_blocks/:appGroupId/edit/:contentBlockId": savedContentBlockNRO,
  "/engagement/templates_and_media/content_blocks/:appGroupId/:contentBlockId/inclusions":
    contentBlockInclusionsNRO,
  "/engagement/templates_and_media/content_blocks/:appGroupId": contentBlocksNRO,
  "/engagement/templates_and_media/email_templates/:appGroupId": emailTemplatesNRO,
  "/engagement/templates_and_media/email_templates/:appGroupId/:emailTemplateId": emailTemplatesNRO,
  "/engagement/templates_and_media/email_templates/:appGroupId/new":
    engagementTemplatesAndMediaEmailTemplatesNewNRO,
  "/engagement/templates_and_media/email_templates/:appGroupId/edit/:id":
    engagementTemplatesAndMediaEmailTemplatesIdNRO,
  "/engagement/templates_and_media/in_app_message_color_profiles/:appGroupId": inAppColorProfilesNRO,
  "/engagement/templates_and_media/landing_page_templates/:appGroupId": landingPageTemplatesNRO,
  "/engagement/templates_and_media/landing_page_templates/:appGroupId/:templateId": landingPageTemplateDetailsNRO,
  "/engagement/templates_and_media/link_templates/:appGroupId": linkTemplatesNRO,
  "/engagement/templates_and_media/link_templates/:appGroupId/:linkTemplateId": linkTemplatesNRO,
  "/engagement/templates_and_media/media_library/:appGroupId": mediaLibraryNRO,
  "/engagement/templates_and_media/webhook_templates/:appGroupId": webhookTemplatesNRO,
  "/engagement/templates_and_media/webhook_templates/:appGroupId/:templateId":
    engagementTemplatesAndMediaWebhookTemplatesTemplateIdNRO,
  "/engagement/templates_and_media/whats_app_templates/:appGroupId":
    engagementTemplatesAndMediaWhatsAppTemplatesNRO,
  "/engagement/templates_and_media/whats_app_templates/new/:appGroupId": WhatsAppTemplatesCreateNRO,
  "/integrations/cloud_data_ingestion/:appGroupId": cloudDataIngestionNRO,
  "/integrations/currents_integrations/currents_integrations/:appGroupId": currentsIntegrationsNRO,
  "/integrations/currents_integrations/new/:destination/:appGroupId":
    integrationsCurrentsIntegrationsNewDestinationNRO,
  "/integrations/currents_integrations/edit/:destination/:appGroupId": integrationsCurrentsIntegrationsEditPillNRO,
  "/integrations/currents_integrations/:appGroupId": currentsIntegrationsNRO,
  "/integrations/datashares_integrations/:appGroupId": datasharesIntegrationsNRO,
  "/integrations/datashares_integrations/:datashareIntegration/:appGroupId": datasharesIntegrationNRO,
  "/integrations/datashares_integrations/create/:appGroupId": datasharesIntegrationCreateNRO,
  "/integrations/datashares_integrations/create/deltashare/:appGroupId": databricksDeltashareCreateNRO,
  "/integrations/datashares_integrations/datashares_integrations/:appGroupId": datasharesIntegrationsNRO,
  "/integrations/datashares_integrations/deltashare/:sharingId/:appGroupId": databricksDeltashareNRO,
  "/integrations/technology_partners/technology-partners/:appGroupId": technologyPartnersListNRO,
  "/integrations/technology_partners/:technologyPartners/:appGroupId": technologyPartnersDetailsNRO,
  "/integrations/technology_partners/:technologyPartners/:appGroupId/:partnerIntegrationId":
    technologyPartnersDetailsNRO,
  "/integrations/technology_partners/:technologyPartners/:appGroupId/:partnerIntegrationId/edit":
    alloysShopifyBridgeIdEditNRO,
  "/integrations/vouchers/:voucherId/:appGroupId": promotionCodeDetailsNRO,
  "/integrations/vouchers/new/:appGroupId": promotionCodeCreateNRO,
  "/integrations/vouchers/vouchers/:appGroupId": promotionCodesNRO,
  "/integrations/vouchers/:appGroupId": promotionCodesNRO,
  "/internal_tools/internal/:appGroupId": toolsDashboardNRO,
  "/knowledge_source/:appGroupId": knowledgeSourceNRO,
  "/knowledge_source/create/:appGroupId": knowledgeSourceCreateNRO,
  "/knowledge_source/edit/:knowledgeSourceId/:appGroupId": knowledgeSourceEditNRO,
  "/mongo_explorer/:appGroupId": mongoExplorerNRO,
  "/decisioning_studio/agents/:appGroupId": offerfitUseCasesNRO,
  "/decisioning_studio/agents/:dsaId/:appGroupId": offerfitUseCaseDetailsNRO,
  "/decisioning_studio/agents/:dsaId/dimensions/:dimensionSlug/:appGroupId": offerfitDimensionDetailsNRO,
  "/roadmap": roadmapNRO,
  "/sdk/debugger/:appGroupId": sdkDebuggerNRO,
  "/users/subscription_groups/:appGroupId": subscriptionGroupsNRO,
  "/users/subscription_groups/:subscriptionGroupId/:appGroupId": usersSubscriptionGroupsSubscriptionGroupIdNRO,
  "/users/subscription_groups/preference_centers/:appGroupId": usersPreferenceCentersNRO,
  "/users/subscription_groups/preference_centers/:appGroupId/new": usersPreferenceCentersNewNRO,
  "/users/subscription_groups/preference_centers/:appGroupId/:id": usersPreferenceCentersIdNRO,
  "/users/subscription_groups/subscription_analytics/:appGroupId": subscriptionAnalyticsNRO,
  "/users/subscription_groups/subscription_groups/:appGroupId": subscriptionGroupsNRO,
  "/users/user_import/:appGroupId": importUsersNRO,
  "/users/user_import/user-import/:appGroupId": importUsersNRO,
  "/users/user_search/:appGroupId": searchUsersNRO,
  "/users/user_search/user-search/:appGroupId": searchUsersNRO,
  "/users/manage_audience/:appGroupId": manageAudienceNRO,
} as const);

/**
 * This is the type returned by `useNavigationRouting`
 */
export type NavigationRoutingRegistryType = typeof navigationRoutingRegistry;

/**
 * This pass-through function gives us strict typing AND perfect inference of the `NavigationRouting` declaration
 */
function makeNavigationRouting<T>(navigationRouting: VerifyDashboardPathnames<T>): T {
  return navigationRouting as T;
}

/**
 * This is a list of all routes that are navigable.
 */
export const navigablePaths = Object.entries(navigationRoutingRegistry)
  .filter(([, nro]) => !!nro.Component)
  .map(([key]) => key as keyof NavigationRoutingRegistryType);

/**
 * This is a list of all routes that are navigable and require feature flippers,
 * mapped to the feature flippers required for each route.
 *
 * @deprecated this is used for backwards compatibility with legacy scenes.
 */
export const navigablePathRequiredFeatureFlippers = navigablePaths.reduce(
  (acc, path) => {
    const nro = navigationRoutingRegistry[path];
    if (nro.Component && nro.componentFeatureFlippers) {
      acc[path] = nro.componentFeatureFlippers;
      if (nro.subroutes) {
        nro.subroutes.forEach((subroute) => {
          acc[path + subroute] = nro.componentFeatureFlippers;
        });
      }
    }
    return acc;
  },
  {} as Record<keyof NavigationRoutingRegistryType, ComponentFeatureFlippers[]>
);
